import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuidV4 from 'uuid/v4';
import EnvironmentUtils from '@spothero/utils/environment';
import Icon from 'common/icon/Icon';
import Tooltip from '@spothero/ui/tooltip';

export default class AmenityIconListItem extends Component {
    static propTypes = {
        iconName: PropTypes.string.isRequired,
        tip: PropTypes.string.isRequired,
        pill: PropTypes.bool
    };
    state = {
        showTooltip: false
    };

    constructor(props) {
        super(props);

        this._isMobile = EnvironmentUtils.isMobileDevice();
        this._uniqueElementClass = `AmenityIconListItem-${uuidV4()}`;
    }

    _onShowTooltip = evt => {
        evt.preventDefault();

        this.setState({
            showTooltip: true
        });
    }

    _onHideTooltip = () => {
        this.setState({
            showTooltip: false
        });
    }

    render() {
        const {
            iconName,
            pill,
            tip
        } = this.props;
        const {
            showTooltip
        } = this.state;
        const classes = classNames(
            'AmenityIconListItem',
            this._uniqueElementClass
        );

        return (
            <Fragment>
                <li
                    className={classes}
                >
                    <span
                        className={(!pill) ? 'AmenityIcon' : 'AmenityPill'}
                        onTouchStart={(this._isMobile) ? this._onShowTooltip : null}
                        onTouchEnd={(this._isMobile) ? this._onHideTooltip : null}
                        onMouseEnter={(!this._isMobile) ? this._onShowTooltip : null}
                        onMouseLeave={(!this._isMobile) ? this._onHideTooltip : null}
                    >
                        {!pill &&
                            <Icon name={iconName} />
                        }
                        {pill &&
                            <span>{tip}</span>
                        }
                    </span>
                </li>
                {showTooltip &&
                    <Tooltip
                        onHidden={this._onHideTooltip}
                        triggerSelector={`.${this._uniqueElementClass}`}
                        showClose={false}
                        position="top"
                    >
                        {tip}
                    </Tooltip>
                }
            </Fragment>
        );
    }
}
